import { CommonEnums } from '../../common.enums';

export class RestJob_Inst {
    dxFlow_Id: number;
    restJob_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    disableFlg: string;
    updateDt: Date;
    updateBy: string;
    body: string;
    endPointUrl: string;
    baseUrl: string;
    flagent_Id: number;
    agentGrpInd: string;
    flagentNm: string;
    pagination: string;
    methodType: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;
    responseType: string;
    body_Valid_Cd: string;
    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.restJob_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.body = CommonEnums.defaults.STRING_EMPTY;
        this.endPointUrl = CommonEnums.defaults.STRING_EMPTY;
        this.baseUrl = CommonEnums.defaults.STRING_EMPTY;
        this.flagent_Id = CommonEnums.defaults.LONG_VAL;
        this.agentGrpInd = CommonEnums.defaults.STRING_EMPTY;
        this.flagentNm = CommonEnums.defaults.STRING_EMPTY;
        this.pagination = CommonEnums.defaults.STRING_EMPTY;
        this.methodType = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled = CommonEnums.defaults.STRING_VAL_NO;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
        this.responseType = CommonEnums.defaults.REST_RESPONSE_FILE_TYPE;
        this.body_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
    }

    copy(): RestJob_Inst {
        let restJob_InstTmp: RestJob_Inst = new RestJob_Inst();

        restJob_InstTmp.dxFlow_Id = this.dxFlow_Id;
        restJob_InstTmp.restJob_Inst_Id = this.restJob_Inst_Id;
        restJob_InstTmp.nm = this.nm;
        restJob_InstTmp.valid_Cd=this.valid_Cd;
        restJob_InstTmp.description = this.description;
        restJob_InstTmp.ver = this.ver;
        restJob_InstTmp.disableFlg = this.disableFlg;
        restJob_InstTmp.updateDt = this.updateDt;
        restJob_InstTmp.updateBy = this.updateBy;
        restJob_InstTmp.body = this.body;
        restJob_InstTmp.endPointUrl = this.endPointUrl;
        restJob_InstTmp.baseUrl = this.baseUrl;
        restJob_InstTmp.flagent_Id = this.flagent_Id;
        restJob_InstTmp.agentGrpInd = this.agentGrpInd;
        restJob_InstTmp.flagentNm = this.flagentNm;
        restJob_InstTmp.pagination = this.pagination;
        restJob_InstTmp.methodType = this.methodType;
        restJob_InstTmp.retryEnabled = this.retryEnabled;
        restJob_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        restJob_InstTmp.retryWaitTime = this.retryWaitTime;
        restJob_InstTmp.responseType = this.responseType;
        restJob_InstTmp.body_Valid_Cd = this.body_Valid_Cd;

        return restJob_InstTmp;
    }

    copyFrom(restJob_InstTmp: RestJob_Inst): void {
        this.dxFlow_Id = restJob_InstTmp.dxFlow_Id;
        this.restJob_Inst_Id = restJob_InstTmp.restJob_Inst_Id;
        this.nm = restJob_InstTmp.nm;
        this.description = restJob_InstTmp.description;
        this.ver = restJob_InstTmp.ver;
        this.valid_Cd = restJob_InstTmp.valid_Cd;
        this.disableFlg = restJob_InstTmp.disableFlg;
        this.updateBy = restJob_InstTmp.updateBy;
        this.updateDt = restJob_InstTmp.updateDt;
        this.body = restJob_InstTmp.body;
        this.endPointUrl = restJob_InstTmp.endPointUrl;
        this.baseUrl = restJob_InstTmp.baseUrl;
        this.flagent_Id = restJob_InstTmp.flagent_Id;
        this.agentGrpInd = restJob_InstTmp.agentGrpInd;
        this.pagination = restJob_InstTmp.pagination;
        this.methodType = restJob_InstTmp.methodType;
        this.retryEnabled = restJob_InstTmp.retryEnabled;
        this.numOfRetryAttempts = restJob_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = restJob_InstTmp.retryWaitTime;
        this.responseType = restJob_InstTmp.responseType;
        this.body_Valid_Cd = restJob_InstTmp.body_Valid_Cd;
    }

    compare(restJob_InstTmp: RestJob_Inst): string {
        let restJob_InstString: string =this.toString(false);
        let restJob_InstTmpString: string = restJob_InstTmp.toString(false);

        if (restJob_InstString != restJob_InstTmpString) {
            return restJob_InstString + ', ' + restJob_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "RestJob_Inst [dxFlow_Id=" + this.dxFlow_Id +
            ", restJob_Inst_Id=" + this.restJob_Inst_Id +
            ", nm=" + this.nm +
            ", description=" + this.description +
            ", ver=" + this.ver +
            ", valid_Cd=" + this.valid_Cd +
            ", disableFlg=" + this.disableFlg +
            ", updateDt=" + this.updateDt +
            ", body=" + this.body +
            ", endPointUrl=" + this.endPointUrl +
            ", baseUrl=" + this.baseUrl +
            ", flagent_Id=" + this.flagent_Id +
            ", agentGrpInd=" + this.agentGrpInd +
            ", flagentNm=" + this.flagentNm +
            ", pagination=" + this.pagination +
            ", methodType=" + this.methodType+
            ",retryEnabled ="+ this.retryEnabled +
            ",numOfRetryAttempts ="+this.numOfRetryAttempts +
            ",retryWaitTime =" +this.retryWaitTime+
            ",responseType ="+ this.responseType+
            ",body_Valid_Cd ="+ this.body_Valid_Cd;

            if (isNotCompare) {
            
            }
    
            str += ']';
    
            return str;
        }
    }
    
